// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.rentguarantee.RentalManagerUserPropertyRentGuaranteeWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  CreateStripeSetupIntentByPolicyIdRequestDto,
  CreateStripeSetupIntentResponseDto,
  GetPremiumPaymentDashboardDataResponseDto,
  GetRentalProtectionPolicyCostByPolicyIdResponseDto,
  GetSecureClaimsUrlForPolicyResponseDto,
  ListingAlias,
  LowFrictionStatusDto,
  RentalManagerRentGuaranteeDisclaimerRequestDto,
  RentGuaranteeDisclaimersDto,
  RentGuaranteeDropPolicyWebApiRequestDto,
  RentGuaranteeListingStateResponseDto,
  RentGuaranteePageResponseDto,
  RentTermDto,
  RetrieveStoredPaymentMethodsResponseDto,
  SavePolicyPaymentMethodRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CheckForActivePaymentTermParams {
  policyId: string;
}
interface GetLowFrictionStatusParams {
  listingAlias: ListingAlias;
}
interface GetPremiumPaymentDashboardDataParams {
  policyId: string;
}
interface GetRentalProtectionManagePageMultiplePoliciesParams {
  disclaimerType?: string;
  listingAlias: ListingAlias;
  stepOffset?: number;
}
interface GetRentalProtectionPolicyCostByPolicyIdParams {
  policyId: string;
}
interface GetRentalProtectionStateForListingMultiPolicyParams {
  listingAlias: ListingAlias;
}
interface GetSecureClaimsUrlForPolicyParams {
  listingAlias: ListingAlias;
  policyId: string;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Options = UseQueryOptions<
  RentTermDto,
  unknown,
  RentTermDto,
  readonly [string, CheckForActivePaymentTermParams]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey = (
  getParams: CheckForActivePaymentTermParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_queryOptions = (
  getParams: CheckForActivePaymentTermParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * check for active payment term for a policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm = (
  getParams: CheckForActivePaymentTermParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_GetKey;

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args {
  postData: CreateStripeSetupIntentByPolicyIdRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Options = UseMutationOptions<
  CreateStripeSetupIntentResponseDto,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args
>;

/**
 * get stripe setup intent for policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args {
  postData: RentGuaranteeDropPolicyWebApiRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args
>;

/**
 * drop rental protection policy and remove experiment stored data
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Options = UseQueryOptions<
  RentGuaranteeDisclaimersDto,
  unknown,
  RentGuaranteeDisclaimersDto,
  readonly [string, RentalManagerRentGuaranteeDisclaimerRequestDto]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_GetKey = (
  postData: RentalManagerRentGuaranteeDisclaimerRequestDto,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Path, postData] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_queryOptions = (
  postData: RentalManagerRentGuaranteeDisclaimerRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get rental protection disclaimer[s]
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers = (
  postData: RentalManagerRentGuaranteeDisclaimerRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Options = UseQueryOptions<
  LowFrictionStatusDto,
  unknown,
  LowFrictionStatusDto,
  readonly [string, GetLowFrictionStatusParams]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey = (
  getParams: GetLowFrictionStatusParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_queryOptions = (
  getParams: GetLowFrictionStatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get low friction status for listing
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus = (
  getParams: GetLowFrictionStatusParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Options =
  UseQueryOptions<
    GetPremiumPaymentDashboardDataResponseDto,
    unknown,
    GetPremiumPaymentDashboardDataResponseDto,
    readonly [string, GetPremiumPaymentDashboardDataParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey = (
  getParams: GetPremiumPaymentDashboardDataParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_queryOptions = (
  getParams: GetPremiumPaymentDashboardDataParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get premium payment dashboard data
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData = (
  getParams: GetPremiumPaymentDashboardDataParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Options =
  UseQueryOptions<
    RentGuaranteePageResponseDto,
    unknown,
    RentGuaranteePageResponseDto,
    readonly [string, GetRentalProtectionManagePageMultiplePoliciesParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_GetKey = (
  getParams: GetRentalProtectionManagePageMultiplePoliciesParams,
) =>
  [
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Path,
    getParams,
  ] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_queryOptions =
  (getParams: GetRentalProtectionManagePageMultiplePoliciesParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_GetKey(
          getParams,
        ),
      queryFn: () =>
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * Get rental protection manage page with multiple policies for listing
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies = (
  getParams: GetRentalProtectionManagePageMultiplePoliciesParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Options =
  UseQueryOptions<
    GetRentalProtectionPolicyCostByPolicyIdResponseDto,
    unknown,
    GetRentalProtectionPolicyCostByPolicyIdResponseDto,
    readonly [string, GetRentalProtectionPolicyCostByPolicyIdParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey = (
  getParams: GetRentalProtectionPolicyCostByPolicyIdParams,
) =>
  [
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path,
    getParams,
  ] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_queryOptions =
  (getParams: GetRentalProtectionPolicyCostByPolicyIdParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey(getParams),
      queryFn: () =>
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * get rental protection policy cost by policyId
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId = (
  getParams: GetRentalProtectionPolicyCostByPolicyIdParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Options =
  UseQueryOptions<
    RentGuaranteeListingStateResponseDto,
    unknown,
    RentGuaranteeListingStateResponseDto,
    readonly [string, GetRentalProtectionStateForListingMultiPolicyParams]
  >;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_GetKey = (
  getParams: GetRentalProtectionStateForListingMultiPolicyParams,
) =>
  [
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Path,
    getParams,
  ] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_queryOptions =
  (getParams: GetRentalProtectionStateForListingMultiPolicyParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_GetKey(
          getParams,
        ),
      queryFn: () =>
        RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * Get rental protection state for listingAlias for multi policy page
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy = (
  getParams: GetRentalProtectionStateForListingMultiPolicyParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Options = UseQueryOptions<
  GetSecureClaimsUrlForPolicyResponseDto,
  unknown,
  GetSecureClaimsUrlForPolicyResponseDto,
  readonly [string, GetSecureClaimsUrlForPolicyParams]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_GetKey = (
  getParams: GetSecureClaimsUrlForPolicyParams,
) => [RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Path, getParams] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_queryOptions = (
  getParams: GetSecureClaimsUrlForPolicyParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get secure lease lock claims url for policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy = (
  getParams: GetSecureClaimsUrlForPolicyParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_GetKey;

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Options = UseQueryOptions<
  RetrieveStoredPaymentMethodsResponseDto,
  unknown,
  RetrieveStoredPaymentMethodsResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey = () =>
  [RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path] as const;

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey(),
    queryFn: () => RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods(httpClient),
  }) as const satisfies QueryOptions;

/**
 * retrieve stored payment methods for user
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods.getKey =
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_GetKey;

export interface RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args {
  postData: SavePolicyPaymentMethodRequestDto;
}

export type RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args
>;

/**
 * save Stripe payment method for policy
 * @deprecated
 */
export const useRentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Args) =>
      RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod(args.postData, httpClient),
  });
};
